import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { StyledMobileTabNavPlainButton } from "./mobile-tab-nav-plain-button.scss";
const MobileTabNavPlainButton = (props)=>{
    const { tabNumber, label, selected, theme } = props;
    return /*#__PURE__*/ _jsxs(StyledMobileTabNavPlainButton, {
        className: classnames("tab-nav-plain-button", {
            selected
        }, theme),
        children: [
            tabNumber && /*#__PURE__*/ _jsx("span", {
                className: "tab-nav-plain-button-text-number",
                children: `${tabNumber}. `
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "tab-nav-plain-button-text-label",
                children: label
            })
        ]
    });
};
export default MobileTabNavPlainButton;
